import messageResource from '../messageResource'
import UserNameFormat from '../util/UserNameFormat'
import {escapeHtmlSymbols} from '../atUtils'

export function createApproversSortingProcessor(allApprovers) {
    const approversMap = {};
    for (let i = 0; i < allApprovers.length; i++) {
        const approver = allApprovers[i];
        approversMap[approver.id] = {
            approver: approver,
            index: i
        };
    }
    return function(approverIds) {
        if (!approverIds) return [];
        const result = [];
        for (let i = 0; i < approverIds.length; i++) {
            const approverEntry = approversMap[approverIds[i]];
            if (approverEntry !== undefined && approverEntry !== null) {
                result.push(approverEntry.approver);
            }
        }
        result.sort(function(a, b) { return approversMap[a.id].index - approversMap[b.id].index; });
        return result;
    }
}

export function formatAssignApproversCellText(userApprovers) {
    var otherApproversCountText =
        userApprovers.length > 1 ?
        ("<br/><span class='otherUsersText'> " +
         messageResource.getMessage((userApprovers.length - 1 === 1) ? "user_list.and_1_other" : "user_list.and_n_others", [userApprovers.length - 1]) +
         "  </span>") :
        "";
    var firstApprover = userApprovers[0];
    return UserNameFormat.formatLFM(escapeHtmlSymbols(firstApprover.firstName), escapeHtmlSymbols(firstApprover.lastName),
        escapeHtmlSymbols(firstApprover.middleInitial)) + "  " + otherApproversCountText;
}

export function checkReloadNeededAfterGetAssignedUsersRequest(assignedUsersData, UGREnabledOnPage, TZGEnabledOnPage, dialog) {
    var needToReload = false;
    if (!assignedUsersData.enabled || !assignedUsersData.approver) {
        var message = messageResource.getMessage(assignedUsersData.enabled ?
                                                 (EnabledFeatures.APWSD ? 'user_list.users_for_approver_dialog.user_is_not_manager' : 'user_list.users_for_approver_dialog.user_is_not_manager.wsd_feature_on' ) :
                                                 'user_list.users_for_approver_dialog.user_disabled');
        alert(message);
        dialog.close();
        needToReload = true;
    }
    // this means UGR was concurrently disabled
    else if (UGREnabledOnPage && assignedUsersData.userGroups === null) {
        alert(messageResource.getMessage("userlist.js.error_ugr_disabled"));
        dialog.close();
        needToReload = true;
    }
    else if (!UGREnabledOnPage && assignedUsersData.userGroups !== null) {
        alert(messageResource.getMessage("userlist.js.error_ugr_enabled"));
        dialog.close();
        needToReload = true;
    }
    else if (TZGEnabledOnPage && assignedUsersData.timeZoneGroups === null) {
        alert(messageResource.getMessage("userlist.js.error_tzg_disabled"));
        dialog.close();
        needToReload = true;
    }
    else if (!TZGEnabledOnPage && assignedUsersData.timeZoneGroups !== null) {
        alert(messageResource.getMessage("userlist.js.error_tzg_enabled"));
        dialog.close();
        needToReload = true;
    }
    return needToReload;
}


// WEBPACK FOOTER //
// ./web/js/administration/userlist_util.js